/** @file Interns attachment placeholder names into dense ids in first-seen order. */

/** Placeholder table under construction: `names[id]` and `index.get(name)` stay in sync. */
export interface Interner {
  names: string[];
  index: Map<string, number>;
  intern(name: string): number;
}

/** Empty interner; `intern` returns the existing id or appends the name. */
export function createInterner(): Interner {
  const names: string[] = [];
  const index = new Map<string, number>();
  return {
    names,
    index,
    intern(name: string): number {
      const known = index.get(name);
      if (known !== undefined) return known;
      index.set(name, names.length);
      names.push(name);
      return names.length - 1;
    },
  };
}
